document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('#login form');
  form.addEventListener('submit', function (event) {
    event.preventDefault();

    localStorage.setItem("applyDiscountCodes", "true")


    const emailField = document.querySelector('#login form input[type="email"]');
    const passwordField = document.querySelector('#login form input[type="password"]');
    const emailError = document.querySelector('.error_email');
    const passwordError = document.querySelector('.error_password');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailField.value === '' || !emailRegex.test(emailField.value)) {
      emailError.style.display = 'flex';
      emailField.style.borderColor = "#CA1722";
    } else {
      emailError.style.display = 'none';
      emailField.style.borderColor = "#9C9C9C";
    }

    if (passwordField.value === '') {
      passwordError.style.display = 'flex';
      passwordField.style.borderColor = "#CA1722";
    } else {
      passwordError.style.display = 'none';
      passwordField.style.borderColor = "#9C9C9C";
    }

    if (emailField.value === '' || !emailRegex.test(emailField.value) || passwordField.value === '') {
      return false;
    }
    form.submit();
  });
});
